export default {
  getEncuestaTpl: state => {
    let table = 'Encuesta'
    switch (state.operacion) {
      case 'edit':
      case 'new':
        table = `${table}Form`
        break
      default:
        table = `${table}List`
        break
    }
    return table
  },
}
